import { createSlice } from '@reduxjs/toolkit';

const wishlistSlice = createSlice({
  name: 'wishlist',
  initialState: {
    items: [],
  },
  reducers: {
    setWishlist(state, action) {
      state.items = action.payload;
    },
    addToWishlist(state, action) {
      // Check if the item is already in the wishlist
      const existingItem = state.items.find(item => item._id === action.payload._id);
      if (!existingItem) {
        state.items.push(action.payload);
      }
    },
    removeFromWishlist(state, action) {
      // Filter the wishlist by the correct id (_id)
      // state.items = state.items.filter(item => item._id !== action.payload._id);
      state.items = state.items.filter(item => item._id !== action.payload);

    },
  },
});

export const { setWishlist, addToWishlist, removeFromWishlist } = wishlistSlice.actions;
export default wishlistSlice.reducer;
